<template>
  <action-button
    v-for="(hActions, actionsIdx) of headerActions"
    :key="`header-actions-${actionsIdx}`"
    :actions="hActions"
    :selected-item-ids="selectedItemIds"
    @item-action="onItemAction"
  />
</template>
<script setup lang="ts">
import {computed} from 'vue'

import ActionButton from './action-button.vue'
import {type ButtonAction, type GridHeaderAction, ButtonActionType, type GridID} from './types'

const props = defineProps({
  actions: {default: null, type: Array as () => Array<GridHeaderAction[] | GridHeaderAction> | null},
  selectedItemIds: {default: (): GridID[] => [], type: Array as () => GridID[]},
})

const emit = defineEmits<{
  (e: 'item-action', action: ButtonAction): void
}>()

// function H
const transformAction = (action: GridHeaderAction): ButtonAction => {
  let actionType = ButtonActionType.url
  if (action.type == 'action') {
    actionType = ButtonActionType.action
  } else if (action.type == 'separator') {
    actionType = ButtonActionType.separator
  }

  return {
    title: action.title || '',
    url: action.url || '',
    name: action.name || '',
    type: actionType,
    cssClass: action.cssClass || action.css_class || '',
    onlyWithSelectedItems: action.onlyWithSelectedItems || action.only_with_selected_items || false,
  }
}

const headerActions = computed((): Array<ButtonAction[]> => {
  const result: Array<ButtonAction[]> = []
  for (const hActions of props.actions || []) {
    if (Array.isArray(hActions)) {
      const multiActions = hActions.map(x => transformAction(x))
      result.push(multiActions)
    } else {
      result.push([transformAction(hActions)])
    }
  }
  return result
})

const onItemAction = (action: ButtonAction): void => {
  emit('item-action', action)
}
</script>
